// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"81722ee4","181":"d38b17b5","184":"34eeeda5","200":"3455f907","249":"9dd0284b","295":"c304e60f","453":"9415623e","635":"b7d307a6","776":"bc44cebe","895":"dd08c6b2","931":"bfad2d1d","948":"b06eb206","952":"86ccb63d","977":"ad900deb"}[chunkId] + ".chunk.js";
};